export default {
  open_standalone: 'Open',
  closed_standalone: 'Gesloten',

  open: 'Open',
  closed: 'Gesloten',
  opening: 'Opent',
  closing: 'Sluit',
  yes_we_are: 'Ja, we zijn',
  sorry_we_are: 'Sorry, wij zijn',
  twentyfourseven: 'Blijvend',
  closing_tomorrow: 'Sluit morgen',
  opening_tomorrow: 'Opent morgen',
  at_x: 'om %x%',
  closing_x: 'Sluit %x%',
  opening_x: 'Opent %x%',

  monday: 'maandag',
  tuesday: 'dinsdag',
  wednesday: 'woensdag',
  thursday: 'donderdag',
  friday: 'vrijdag',
  saturday: 'zaterdag',
  sunday: 'zondag',

  businessHours: 'Kantooruren'
};



// WEBPACK FOOTER //
// ./src/commons/translations/nl.js